import { SortDirection } from "@tanstack/table-core/src/features/Sorting";
import { Activity } from "PFTypes";
import React, { Dispatch, PropsWithChildren, SetStateAction, useContext, useMemo, useState } from "react";

import { useActivityPageContext } from "../activity_page_context";

type ActivityHistoryProviderProps = {};

export type ActivityHistoryContextType = ActivityHistoryProviderProps & {
  activity: Activity;
  sort: SortDirection;
  setSort: Dispatch<SetStateAction<SortDirection>>;
};

const ActivityHistoryContext = React.createContext<ActivityHistoryContextType>(
  {} as ActivityHistoryContextType
);

export const ActivityHistoryProvider = ({ children }: PropsWithChildren<ActivityHistoryProviderProps>) => {
  const [sort, setSort] = useState<SortDirection>("desc");
  const { task } = useActivityPageContext();

  const contextValue = useMemo(
    () => ({
      sort,
      setSort,
      activity: task!
    }),
    [task, sort]
  );

  if (!task) {
    return null;
  }

  return <ActivityHistoryContext.Provider value={contextValue}>{children}</ActivityHistoryContext.Provider>;
};

export const useActivityHistoryContext = () => useContext(ActivityHistoryContext);
